import { z } from "zod";
export const PageHeaderBooleanSchema = z
    .enum(["true", "false"])
    .transform((value) => value === "true");
export const PageHeaderCountSchema = z
    .string()
    .regex(/^\d+$/)
    .transform(Number)
    .pipe(z.number().int().nonnegative());
export const AppointmentAvailabilitySchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("none") }),
    z.object({ kind: z.literal("one"), eventId: z.string() }),
    z.object({ kind: z.literal("many") }),
]);
export const CustomerPageMetaSchema = z.object({
    searchPlaceholder: z.string().optional(),
    totalCount: z.number().int().nonnegative(),
    hasCustomers: z.boolean(),
});
export const ServiceDescriptionPageMetaSchema = z.object({
    appointments: AppointmentAvailabilitySchema.optional(),
});
export const InvoicePageMetaSchema = z
    .object({
    totalCount: z.number().int().nonnegative(),
    hasInvoices: z.boolean(),
    appointments: AppointmentAvailabilitySchema.optional(),
})
    .refine((meta) => meta.hasInvoices || meta.appointments !== undefined, {
    path: ["appointments"],
    message: "Appointment availability is required when invoices are absent",
});
export const AgendaEventsPageMetaSchema = z.object({ hasAppointments: z.boolean() });
export const EventPageMetaSchema = z.object({
    totalCount: z.number().int().nonnegative(),
    totalInLate: z.number().int().nonnegative(),
    totalToBePaid: z.number().int().nonnegative(),
    hasAppointments: z.boolean(),
});
//# sourceMappingURL=pageReads.js.map